import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { capitalize } from 'lodash'
import { withStyles } from 'beam/dist/styles'
import BeamIcon from 'beam/dist/BeamIcon'
import IconButton from 'beam/dist/IconButton'
import Menu, { MenuItem } from 'beam/dist/Menu'
import { ListItemIcon, ListItemText } from 'beam/dist/List'
import Checkbox from 'beam/dist/Checkbox'
import { ROLE_ANALYST, ROLE_EVALUATOR } from './mediaPlayer.constants'
import { authenticatedUserShape, PERMISSIONS, withAuthenticatedUser } from '../../../Permissions'

const styles = theme => ({
  backItem: {
    outline: 'none',
  },
  backButton: {
    marginLeft: theme.spacing(-1),
    padding: theme.spacing(0.5),
  },
  backText: {
    marginLeft: theme.spacing(-1),
  },
  hasSwitch: {
    paddingRight: theme.spacing(7),
  },
})

class MediaPlayerMultiMenu extends Component {
  static propTypes = {
    role: PropTypes.string.isRequired,
    markForTraining: PropTypes.bool.isRequired,
    markForHR: PropTypes.bool.isRequired,
    onRoleChange: PropTypes.func.isRequired,
    onMarkForTrainingChange: PropTypes.func.isRequired,
    onMarkForHRChange: PropTypes.func.isRequired,
    authenticatedUser: authenticatedUserShape.isRequired,
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  }

  state = {
    anchorEl: null,
    open: false,
    workspaceSubMenuOpen: false,
  }

  handleOpen = anchorEl => {
    this.setState(() => ({
      anchorEl,
      open: true,
      workspaceSubMenuOpen: false,
    }))
  }
  handleClose = () => {
    this.setState(() => ({
      anchorEl: null,
      open: false,
    }))
  }
  setStatePropertyTrue = stateProperty => () => {
    this.setState(() => ({ [stateProperty]: true }))
  }
  setStatePropertyFalse = stateProperty => () => {
    this.setState(() => ({ [stateProperty]: false }))
  }

  handleRoleChange = role => () => {
    this.props.onRoleChange(role)

    this.handleClose()
  }

  render() {
    const { anchorEl, open } = this.state

    const {
      role,
      markForTraining,
      markForHR,
      onMarkForTrainingChange,
      onMarkForHRChange,
      classes,
      t,
      authenticatedUser: { hasPermission },
    } = this.props

    const rootMenu = []
    if (hasPermission(PERMISSIONS.MARK_FOR_TRAINING)) {
      rootMenu.push(
        <MenuItem
          dense
          auto-qa-id="mediaPlayerMultiMenu-markForTrainingCheckbox"
          data-testid="mediaPlayerMultiMenu-markForTrainingCheckbox"
          key="markForTraining"
          button
          onClick={onMarkForTrainingChange}
        >
          <Checkbox checked={markForTraining} tabIndex="-1" disableRipple />
          <ListItemText primary={t('markForTraining')} />
        </MenuItem>,
      )
    }
    if (hasPermission(PERMISSIONS.MARK_FOR_HR)) {
      rootMenu.push(
        <MenuItem
          dense
          auto-qa-id="mediaPlayerMultiMenu-markForHRCheckbox"
          data-testid="mediaPlayerMultiMenu-markForHRCheckbox"
          key="markForHR"
          button
          onClick={onMarkForHRChange}
        >
          <Checkbox checked={markForHR} tabIndex="-1" disableRipple />
          <ListItemText primary={t('markForHR')} />
        </MenuItem>,
      )
    }

    // if (
    //   hasAnyPermission([
    //     PERMISSIONS.VIEW_AUDIO_ANALYTICS,
    //     PERMISSIONS.VIEW_LVCSR_ANALYTICS,
    //     PERMISSIONS.VIEW_DESKTOP_ANALYTICS
    //   ]) &&
    //   hasPermission(PERMISSIONS.VIEW_EVALUATIONS)
    // ) {
    //   rootMenu.unshift(
    //     <MenuItem dense button divider onClick={this.setStatePropertyTrue('workspaceSubMenuOpen')}>
    //       <ListItemText primary={`${t(['workspace', 'Workspace'])}: ${capitalize(role)}`} />
    //       <BeamIcon>ChevronRight</BeamIcon>
    //     </MenuItem>
    //   )
    // }

    const workspaceSubMenu = [
      <MenuItem dense key={0} button={false} divider className={classes.backItem}>
        <IconButton className={classes.backButton} onClick={this.setStatePropertyFalse('workspaceSubMenuOpen')}>
          <BeamIcon>ArrowLeft</BeamIcon>
        </IconButton>
        <ListItemText className={classes.backText} primary={t('chooseAWorkspace', 'Choose a workspace')} />
      </MenuItem>,
      <MenuItem dense key={1} onClick={this.handleRoleChange(ROLE_ANALYST)}>
        {role === ROLE_ANALYST && (
          <ListItemIcon>
            <BeamIcon>Check</BeamIcon>
          </ListItemIcon>
        )}
        <ListItemText inset={role !== ROLE_ANALYST} primary={capitalize(ROLE_ANALYST)} />
      </MenuItem>,
      <MenuItem dense key={2} onClick={this.handleRoleChange(ROLE_EVALUATOR)}>
        {role === ROLE_EVALUATOR && (
          <ListItemIcon>
            <BeamIcon>Check</BeamIcon>
          </ListItemIcon>
        )}
        <ListItemText inset={role !== ROLE_EVALUATOR} primary={capitalize(ROLE_EVALUATOR)} />
      </MenuItem>,
    ]

    const getMenuItems = () => {
      const { workspaceSubMenuOpen } = this.state

      if (!workspaceSubMenuOpen) {
        return rootMenu
      } else if (workspaceSubMenuOpen) {
        return workspaceSubMenu
      }
    }

    return getMenuItems().length > 0 ? (
      <Fragment>
        <IconButton
          color="inherit"
          aria-owns={open ? 'multi-menu' : undefined}
          aria-haspopup="true"
          auto-qa-id="mediaPlayerMultiMenu-open"
          data-testid="mediaPlayerMultiMenu-open"
          onClick={event => {
            this.handleOpen(event.currentTarget)
          }}
        >
          <BeamIcon>DotsVertical</BeamIcon>
        </IconButton>

        <Menu
          id="multi-menu"
          auto-qa-id="mediaPlayerMultiMenu-menu"
          data-testid="mediaPlayerMultiMenu-menu"
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={open}
          onClose={this.handleClose}
        >
          {getMenuItems()}
        </Menu>
      </Fragment>
    ) : null
  }
}

export { MediaPlayerMultiMenu as RawMediaPlayerMultiMenu }

export default withStyles(styles)(withTranslation()(withAuthenticatedUser(MediaPlayerMultiMenu)))
